import { useState, useEffect } from "react";
import PropTypes from "prop-types";

const GoldenSpacing = ({ children, referenceElementId, targetElementClass }) => {
    const [spacing, setSpacing] = useState(0);

    useEffect(() => {
        const referenceElement = document.getElementById(referenceElementId);
        const targetElement = document.querySelector(targetElementClass);

        console.log("referenceElement:", referenceElement);
        console.log("targetElement:", targetElement);

        if (referenceElement && targetElement) {
            console.log("referenceElement offset:", referenceElement.offsetHeight);
            console.log("targetElement offset:", targetElement.offsetTop);
        } else {
            console.warn("GoldenSpacing: Элементы не найдены!");
        }


        if (referenceElement && targetElement) {
            const targetPaddingTop = parseInt(window.getComputedStyle(targetElement).paddingTop, 10);
            const goldenSpacing = targetPaddingTop * 1.618;

            setSpacing(goldenSpacing);
        }
    }, [referenceElementId, targetElementClass]);

    return <div style={{ marginTop: `${spacing}px` }}>{children}</div>;
};

export default GoldenSpacing;

GoldenSpacing.propTypes = {
    children: PropTypes.node,
    referenceElementId: PropTypes.string,
    targetElementClass: PropTypes.string,
}